import * as React from 'react';
import { DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { organizerSlice } from '../../../store/slice/slice';
import { DialogActionButtons } from '../../dialogActionButtons/DialogActionButtons';
import { BootstrapDialog, dialogStyles, iconButtonStyles, useStyles } from './modalSuccess.styles';
import { IProps } from './types';

export const ModalSuccess = ({ open, title, text }: IProps): JSX.Element => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(organizerSlice.actions.setSuccessVisible(false));
  };

  const actionProps = {
    submit: 'GOT IT',
    handleClose,
    handleSubmit: handleClose,
  };

  return (
    <div>
      <BootstrapDialog
        className={classes.modal}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          sx={dialogStyles}
          className={classes.modalMainTitle}
        >
          {title}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={iconButtonStyles}
          >
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className={classes.modalDescription}>
            {text}
          </div>
        </DialogContent>
        <DialogActions>
          <DialogActionButtons {...actionProps} />
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};
